import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'bll-skeleton-text',
  templateUrl: './skeleton-text.component.html',
  // styleUrls: ['./skeleton-text.scss'],
  // encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BllSkeletonTextComponent {
  @Input() width: string = '100%';
  @Input() fontSize: string = '1em';
  constructor() {}
}
